const Roles = {
    Coach: "companycoach",
    Staff: "companystaff",
    Administrator: "companyadmin",
    Student: "student",
};

export default Roles;